import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import Footer from "../layout/footer";
import './award.css';

class Awards extends Component {
    state = {
    }
    goToAwardProgram = () => {
        var d = document.getElementById("awardProgram");
        var topPos = d.offsetTop;
        var header = document.getElementById("nav");
        let headerHeight = header.offsetHeight;

        window.scrollTo({
            top: (topPos - headerHeight),
            left: 0,
            behavior: "smooth"
        });
    }
    updateVideo(type) {
        let videoSrc;
        if (type === 'session_1') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/Welcome%20%26%20Opening%20Speeches.mp4';
        } else if (type === 'session_2') {
            videoSrc = 'https://storage.googleapis.com/emsd_video/Launching%20Ceremony%20of%20E%26M%20AI%20Lab.mp4';
        }

        let video = document.getElementById('video');

        video.setAttribute('src', videoSrc + "?autoPlay=1&amp;modestbranding=1&amp;showinfo=0");
    }
    componentDidMount() {
        let myModal = document.getElementById('myModal');
        let video = document.getElementById('video');

        myModal.addEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });
    }
    componentWillUnmount() {
        let myModal = document.getElementById('myModal');
        let video = document.getElementById('video');

        myModal.removeEventListener('hide.bs.modal', function () {
            video.setAttribute('src', '');
        });
        this.setState = () => false;
    }
    render() {
        const { t } = this.props;
        let path = window.location.pathname;
        let match = path.slice(0, 3);

        return (
            <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
                <MetaTags>
                    <title>{t('award-meta-title')}</title>
                    <meta name="title" content={t('award-meta-title')} />
                    <meta name="description" content={t('award-meta-description')} />
                    <meta name="keywords" content={t('award-meta-keywords')} />
                </MetaTags>
                <div id="div-award">
                    <div className="award-banner pt-5">
                        <div className="container-fluid d-flex justify-content-center align-items-center pt-5">
                            <div>
                                <div className="award-banner-headline-1 text-center my-4">{t('award-banner-headline-1-1')}<br className="d-sm-none d-block" />{t('award-banner-headline-1-2')}</div>
                                <div className="award-banner-headline-2 text-center my-4">{t('award-banner-headline-2')}</div>
                                <div className="award-banner-headline-3 text-center my-4">{t('award-banner-headline-3-1')}<br className="d-md-none" />{t('award-banner-headline-3-2')}</div>
                                <div className="d-none d-sm-block award-banner-headline-4 text-center my-3">{t('award-banner-headline-4')}</div>
                                <div className="d-sm-none award-banner-headline-4 text-center mt-3">{t('award-banner-headline-4-1')}</div>
                                <div className="d-sm-none award-banner-headline-4 text-center mt-2 mb-3">{t('award-banner-headline-4-2')}</div>
                                <div className="d-flex justify-content-center mt-5">
                                    <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border"><button className="btn btn-conf btn-highlight05 w-100 py-2 px-5">{t('Register Now award')}</button></a>
                                </div>

                                <div className="container-fluid d-flex justify-content-center my-5">
                                    <div className="col-12 col-lg-10">
                                        <p><b>{t('award-intro-text-1')}</b>{t('award-intro-text-2')}</p>
                                        <p>{t('award-intro-text-3')}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div id="awardProgram">
                        <div className="text-center">
                            <h2>{t('award-rundown-headline')}</h2>
                        </div>

                        <div className="award-rundown-detail py-5">
                            <div className="container-fluid">
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="award-rundown-detail-prorgram-time-xl text-end">{t('award-rundown-detail-prorgram-time-1')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className="award-rundown-detail-prorgram-info-title">{t('award-rundown-detail-prorgram-title-1')}</div>
                                            {/* <div className={t('award-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_1')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="award-rundown-detail-prorgram-time-xl text-end">{t('award-rundown-detail-prorgram-time-2')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className="award-rundown-detail-prorgram-info-title">{t('award-rundown-detail-prorgram-title-2')}</div>
                                            {/* <div className={t('award-rundown-detail-prorgram-replay TXT_bold d-flex align-self-center')} data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('session_2')}><span>{t('conf-rundown-detail-prorgram-text-replay')}</span><div className="replay-icon"></div></div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="award-rundown-detail-prorgram-time-xl text-end">{t('award-rundown-detail-prorgram-time-3')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className="award-rundown-detail-prorgram-info-title">{t('award-rundown-detail-prorgram-title-3')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="award-rundown-detail-prorgram-time-xl text-end">{t('award-rundown-detail-prorgram-time-4')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className="award-rundown-detail-prorgram-info-title">{t('award-rundown-detail-prorgram-title-4')}</div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="award-rundown-detail-prorgram-time-xl text-end">{t('award-rundown-detail-prorgram-time-5')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className="award-rundown-detail-prorgram-info-title">{t('award-rundown-detail-prorgram-title-5')}</div>
                                        </div>
                                    </div>
                                </div>*/}
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="award-rundown-detail-prorgram-time-xl text-end">{t('award-rundown-detail-prorgram-time-6')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                            <div className="award-rundown-detail-program-break-line"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className="award-rundown-detail-prorgram-info-title">{t('award-rundown-detail-prorgram-title-6')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="div-award-rundown-detail-prorgram col-12 col-lg-10 d-flex">
                                    <div className="award-rundown-detail-prorgram-time-xl text-end">{t('award-rundown-detail-prorgram-time-7')}</div>
                                    <div className="award-rundown-detail-program-break d-flex justify-content-center">
                                        <div>
                                            <div className="award-rundown-detail-program-break-light-xl"></div>
                                        </div>
                                    </div>
                                    <div className="award-rundown-detail-program-info">
                                        <div>
                                            <div className="award-rundown-detail-prorgram-info-title">{t('award-rundown-detail-prorgram-title-7')}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center mb-5">
                                    <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border"><button className="btn btn-conf btn-highlight05 w-100 py-2 px-5">{t('Register Now award')}</button></a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
                {/*  Modal */}
                <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>

                                <div className="ratio ratio-16x9">
                                    <video autoPlay playsInline controls src="" id="video">
                                        <source src="" type="video/mp4" />
                                    </video>
                                    {/* <iframe className="embed-responsive-item" src="" id="video" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" title="Video"></iframe> */}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/*  Modal */}
                <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content bg-black">
                            <div className="modal-body">
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>


                                <p>{t('alert-msg-1')}</p>
                                {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}

                            </div>

                        </div>
                    </div>
                </div>

            </div >



        );
    }
}

// extended main view with translate hoc
export default translate("translations")(Awards);



// WEBPACK FOOTER //
// ./src/components/pages/award.js